import { createFileRoute, redirect } from "@tanstack/react-router";
import { resolveAuthenticatedLandingTarget } from "@/lib/auth-landing";
import { LoginPage } from "@/pages/login.page";

export const Route = createFileRoute("/login")({
  beforeLoad: async ({ context }) => {
    if (context.auth.isAuthenticated) {
      const target = await resolveAuthenticatedLandingTarget(
        context.auth.user?.preferred_display_board ?? null,
      );
      throw redirect(target);
    }
  },
  component: LoginPage,
});
